export default [{
    "seasonId": "",
    "fromDate": new Date(),
    "toDate": new Date(),
    "seasonName": "",
    "activeFlg": false,
    "pFromDate": new Date(),
    "pToDate": new Date(),
    "dispatchFromDate": new Date(),
    "dispatchToDate": new Date(),
    "pDispatchFromDate": new Date(),
    "pDispatchToDate": new Date(),
}]